const convertToSelectOptions = (options, { isSort }) => {
  const sortedOptions = isSort ? options.sort() : options;
  return sortedOptions.map(option => ({ label: option, value: option }));
};

export default convertToSelectOptions;
